import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import FormControl from "@material-ui/core/FormControl";
import Input from "@material-ui/core/Input";
import InputAdornment from "@material-ui/core/InputAdornment";
import { IconButton, Button } from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import PremiumBadge from "../../components/Frequents/PremiumBadge";
import update from "immutability-helper";

const useStyles = makeStyles({
    container: {
        width: "100%",
        overflowY: "hidden"
    },
    underline: {
        "&&:after": {
            borderBottom: "none"
        }
    }
});

export default props => {
    const classes = useStyles();

    return (
        <TableContainer className={classes.container}>
            <Table stickyHeader aria-label="sticky table">
                <TableHead>
                    <TableRow>
                        {props.columns.map(column => (
                            <TableCell key={column.id} align={column.align} style={{ maxWidth: column.maxWidth }}>
                                {column.label}
                                {column.id === "pause" && props.therapist.plan !== "pro" && <PremiumBadge />}
                            </TableCell>
                        ))}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {props.treatments.map((treatment, index) => {
                        return (
                            <TableRow hover role="checkbox" tabIndex={-1} key={index}>
                                {props.columns.map(column => {
                                    const value = treatment[column.id];
                                    return (
                                        <TableCell
                                            key={column.id}
                                            align={column.align}
                                            style={{ width: column.maxWidth }}>
                                            {column.id === "slet" ? (
                                                <IconButton
                                                    onClick={event => {
                                                        if (!window.confirm("Er du sikker?")) return;
                                                        props.deleteTreatment(treatment.id);
                                                    }}
                                                    aria-label="delete treatment"
                                                    component="span">
                                                    <DeleteIcon />
                                                </IconButton>
                                            ) : (
                                                <Button>
                                                    <FormControl style={{ width: "100%" }}>
                                                        <Input
                                                            disabled={
                                                                column.id === "pause" && props.therapist.plan !== "pro"
                                                            }
                                                            disableUnderline={true}
                                                            alignment={"right"}
                                                            type={column.id === "name" ? "text" : "number"}
                                                            value={
                                                                value === null
                                                                    ? null
                                                                    : column.type === "text"
                                                                    ? value
                                                                    : column.type === "time"
                                                                    ? Number(value / 60).toString()
                                                                    : Number(value).toString()
                                                            }
                                                            onChange={event =>
                                                                props.saveTreatment(
                                                                    update(props.treatments, {
                                                                        [index]: {
                                                                            $set: update(treatment, {
                                                                                [column.id]: {
                                                                                    $set:
                                                                                        column.type === "time"
                                                                                            ? event.target.value * 60
                                                                                            : event.target.value
                                                                                }
                                                                            })
                                                                        }
                                                                    }),
                                                                    index
                                                                )
                                                            }
                                                            Button
                                                            endAdornment={
                                                                <InputAdornment position="end">
                                                                    {column.format}
                                                                </InputAdornment>
                                                            }
                                                            style={{
                                                                width: column.maxWidth
                                                            }}
                                                        />
                                                    </FormControl>
                                                </Button>
                                            )}
                                        </TableCell>
                                    );
                                })}
                            </TableRow>
                        );
                    })}
                </TableBody>
            </Table>
        </TableContainer>
    );
};
